<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="用户名：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="电话号码：">
            <el-input clearable v-model="filterForm.phone" placeholder="请输入电话号码"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
        </div>
      </el-form>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false"
          :align="x.align||'center'" header-align="center"></el-table-column>

        <el-table-column label="操作" width="340" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="viewLogHandler(scope.row.id)">查看日志</el-button>
          </template>
        </el-table-column>

      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看日志 -->
    <el-dialog
      title="日志列表" :modal="false" width="1400px" center
      :visible.sync="dialogVisible_loglist"
      :close-on-click-modal="false" @close="dialogClose_loglist">
      
      <section>
        <el-form class="section-filter" :model="filterForm_loglist" :inline="true" label-width="100px">
          <div class="filter-col">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="filterForm_loglist.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="filterForm_loglist.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <!-- <div class="filter-area">
            <div class="filter-area-label">地区：</div>
            <AreaPicker ref="AreaPicker" @getData="filterHandler" />
          </div> -->
          <div class="filter-btn">
            <el-button type="primary" @click="filterHandler_()" icon="el-icon-search">查询</el-button>
            <el-button type="" @click="resetHandler_()" icon="el-icon-refresh-right">重置</el-button>
          </div>
        </el-form>
      </section>


      <el-table :data="tableData_loglist" max-height="550" border @selection-change="(val)=>{selectRow=val}">
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo_loglist" :key="i"
          :prop="x.key" :label="x.label" align="center"></el-table-column>
        <el-table-column label="详情" type="expand">
          <template slot-scope="props">
            <div v-if="props.row.fileIds_">
              <span v-for="(x1,i1) in props.row.fileIds_" :key="i1" style="margin-left:10px">
                <el-image  style="width: 100px; height: 100px" :src="x1" :preview-src-list="props.row.fileIds_"></el-image>
              </span>
            </div>
            <div v-else>
              <span>无详情图片</span>
            </div>
            <div class="content">
              <h3>服务内容：</h3>
              <p>{{props.row.serviceContent}}</p>
            </div>
            <div class="content">
              <h3>服务结果：</h3>
              <p>{{props.row.serviceResult}}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <paging :pagesData="pageData_loglist" @set_page_number="pageNumberChange_loglist"></paging>
    </el-dialog>

  </div>
</template>

<script>
import AreaPicker from '@/components/AreaPicker_3'
// import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixins from '@/Mixins/mixin_com'
export default {
  mixins: [mixins],
  components: { AreaPicker, Pagenation },
  data() {
    return {
      sign: 'log_shengcha',
      dialogTitle: '日志审查',

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },
        { key: 'areaName', label: '地区' },

        { key: 'name', label: '用户名' },
        { key: 'phone', label: '电话号码' },
      ],

      helpId: '',
      dialogVisible_loglist: false,
      filterForm_loglist: {},
      tableData_loglist: [],
      baseInfo_loglist: [
        { key: 'areaName', label: '地区' },
        { key: 'operateLogTypeT', label: '操作日志类型' },
        { key: 'serviceContent', label: '帮扶内容' },
        { key: 'serviceResult', label: '帮扶结果' },
        { key: 'helpName', label: '帮扶责任人' },
        { key: 'helpPhone', label: '电话号码' },
        { key: 'targetName', label: '目标姓名' },
        { key: 'targetPhone', label: '目标电话' },
        { key: 'time', label: '操作时间' },
      ],
      pageData_loglist: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },
    }
  },
  methods: {
    viewLogHandler(helpId) {
      console.log(`%c工作人员ID:`, 'color: #00f;', helpId)
      this.helpId = helpId
      this.dialogVisible_loglist = true
    },
    filterHandler_() {
      let rD = {
        ...this.filterForm_loglist,
        helpId: this.helpId,
        pageNumber: this.pageData_loglist.currentPage,
      }
      this.$api.getlog(rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c日志列表:`, 'color: #f00;', _R)
          this.tableData_loglist = _R.map(x1 => {
            x1.operateLogTypeT = this.$public.type[x1.operateLogType - 1]
            x1.areaName = x1.province + x1.city + x1.county + x1.town + x1.village
            if (x1.fileIds) {
              x1.fileIds_ = x1.fileIds.split(',')
              x1.fileIds_.forEach((x2, i2) => {
                x1.fileIds_[i2] = this.$api.imgUrl + '/user/img/' + x2
              })
            }
            return x1
          })
          this.pageData_loglist.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    resetHandler_() {
      this.filterForm_loglist = {}
    },
    dialogClose_loglist() {
      this.filterForm_loglist = {}
      this.tableData_loglist = []
      this.pageData_loglist = {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      }
    },
    pageNumberChange_loglist(pageNumer) {
      this.pageData_loglist.currentPage = pageNumer
      this.viewContractHandler()
    },

    getData(rD = {}) {
      rD.workPerson = true
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          // this.tableData = _R
          this.tableData = _R.map(x => {
            x.areaName = x.province + x.city + x.county + x.town + x.village
            return x
          })
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}
</style>